import "./Indicator.scss";
import cn from "classnames";

const Indicator = ({
  iconIndicator,
  className,
  textLabel,
  isActive,
  onClick,
}) => {
  return (
    <div className="indicator__wrap">
      <div onClick={onClick} className={cn(className, { active: isActive })}>
        <img src={iconIndicator} alt="icon" />
      </div>
      <span>{textLabel}</span>
    </div>
  );
};

export default Indicator;
